export function initServiceWorkers() {
    resetCacheForUpdate();
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });
    }
}

async function deleteCaches() {
    try {
        const keys = await window.caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
    } catch (err) {
        console.log('deleteCache err: ', err);
    }
}

// run this function on your app load
export function resetCacheForUpdate() {
    if (!localStorage.getItem('cacheReset')) {
        deleteCaches().then((_) => {
            localStorage.setItem('cacheReset', 'yes');
        });
    }
}
